export function Wordmark() {
	return (
		<span className="flex items-center gap-2" data-testid="wordmark">
			<span className="flex size-7 items-center justify-center rounded-md bg-signal font-display text-lg leading-none font-bold text-signal-foreground">
				K
			</span>
			<span className="font-display text-xl font-bold tracking-wide uppercase">
				Knowsball
			</span>
		</span>
	);
}
